// extracted by mini-css-extract-plugin
module.exports = {"popularGiftChip":"PopularGiftChip_popularGiftChip__kFXfO"};